"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontStyleName = void 0;
/**
 * Enum representing different font styles.
 * Note: Please don't change the order of this enum. if you need to change it, please confirm with the product team.
 * @enum {string}
 */
var FontStyleName;
(function (FontStyleName) {
    FontStyleName["THIN"] = "THIN";
    FontStyleName["EXTRALIGHT"] = "EXTRALIGHT";
    FontStyleName["LIGHT"] = "LIGHT";
    FontStyleName["REGULAR"] = "REGULAR";
    FontStyleName["MEDIUM"] = "MEDIUM";
    FontStyleName["SEMIBOLD"] = "SEMIBOLD";
    FontStyleName["BOLD"] = "BOLD";
    FontStyleName["EXTRABOLD"] = "EXTRABOLD";
    FontStyleName["BLACK"] = "BLACK";
    FontStyleName["THINITALIC"] = "THINITALIC";
    FontStyleName["EXTRALIGHTITALIC"] = "EXTRALIGHTITALIC";
    FontStyleName["LIGHTITALIC"] = "LIGHTITALIC";
    FontStyleName["ITALIC"] = "ITALIC";
    FontStyleName["MEDIUMITALIC"] = "MEDIUMITALIC";
    FontStyleName["SEMIBOLDITALIC"] = "SEMIBOLDITALIC";
    FontStyleName["BOLDITALIC"] = "BOLDITALIC";
    FontStyleName["EXTRABOLDITALIC"] = "EXTRABOLDITALIC";
    FontStyleName["BLACKITALIC"] = "BLACKITALIC";
})(FontStyleName || (exports.FontStyleName = FontStyleName = {}));
//# sourceMappingURL=types.js.map